export default {
    data() {
        return {
            filterMap: new Map(),
            lastFilterKey: null,
            openSortFilter: new Set(),
            checkedFilterMap: new Map(),//for config
        }
    },

    methods: {
        addToFilter(key, disableSet) {
            this.lastFilterKey = key;
            this.filterMap.set(key, disableSet);
            this.changeFlag++;
        },
        addToCheckedFilter(key, checkedSet) {
            this.checkedFilterMap.set(key, checkedSet);
            this.changeFlag++;
        },
        removeFilter(key) {
            this.filterMap.delete(key);
            this.checkedFilterMap.delete(key);
            this.changeFlag -= 10;
            //should recover
            if (this.lastFilterKey === key) {
                this.$nextTick(() => {
                    for (let key of this.filterMap.keys()) {
                        let el = this.getRefEl('RFD_' + key);
                        el && el.recoverDistinctCells();
                    }
                })
            }
        },
        isFiltered() {
            return this.filterMap.size > 0;
        },

        filterRows(rows) {
            if (!this.isFiltered()) {
                return rows;
            }
            let tempList = [];
            for (let row of rows) {
                let pass = true;
                for (let key of this.filterMap.keys()) {
                    let item = row[key];
                    if (!this.hasCode(item)) {
                        item = '(blanks)';
                    }
                    let disableSet = this.filterMap.get(key);
                    if (disableSet.has(item)) {
                        pass = false;
                        break;
                    }
                }
                if (pass) {
                    tempList.push(row);
                }
            }
            return tempList;
        },
    },
}
